import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../service/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private authService = inject(AuthenticationService);
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    this.handle400Error();
                }
                throw error; // Rethrow the error
            })
        );
    }
    private handle400Error() {
        console.log('A 400 error occurred. Executing custom function.');
        this.authService.logout();
    }
}
